
const reports = [
  {
    title: 'Pedidos por Periodo',
    description: 'Volume de pedidos e receita por periodo',
    icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    title: 'Produtos Mais Vendidos',
    description: 'Ranking de produtos por quantidade vendida',
    icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    color: 'bg-green-50 text-green-600',
  },
  {
    title: 'Performance de Entregas',
    description: 'Tempo medio de entrega por transportadora',
    icon: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4',
    color: 'bg-blue-50 text-blue-600',
  },
  {
    title: 'Devolucoes e Motivos',
    description: 'Analise de devolucoes por tipo e motivo',
    icon: 'M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6',
    color: 'bg-orange-50 text-orange-600',
  },
  {
    title: 'Ocorrencias por Tipo',
    description: 'Distribuicao de ocorrencias e prioridades',
    icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z',
    color: 'bg-red-50 text-red-600',
  },
  {
    title: 'Movimentacao de Estoque',
    description: 'Entradas e saidas de estoque por periodo',
    icon: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4',
    color: 'bg-purple-50 text-purple-600',
  },
];

function Icon({ path }: { path: string }) {
  return (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={path} />
    </svg>
  );
}

export default function ReportsPage() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {reports.map((report) => (
          <div
            key={report.title}
            className="bg-white rounded-xl p-6 shadow-sm border border-dark-100 hover:shadow-md transition-shadow cursor-pointer"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${report.color}`}>
              <Icon path={report.icon} />
            </div>
            <h3 className="text-lg font-semibold text-dark-900 mb-2">{report.title}</h3>
            <p className="text-sm text-dark-500">{report.description}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
        <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Pedidos nos Ultimos 7 Dias</h3>
        <div className="flex items-end gap-2 h-48">
          {[35, 52, 28, 67, 45, 73, 41].map((height, index) => (
            <div key={index} className="flex-1 flex flex-col items-center gap-2">
              <div
                className="w-full bg-primary-600 rounded-t-md transition-all hover:bg-primary-700"
                style={{ height: `${height}%` }}
              ></div>
              <span className="text-xs text-dark-500">
                {new Date(Date.now() - (6 - index) * 86400000).toLocaleDateString('pt-BR', { weekday: 'short' })}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
          <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Receita Mensal</h3>
          <div className="space-y-3">
            {[
              { month: 'Jan', value: 45000, pct: 90 },
              { month: 'Fev', value: 38000, pct: 76 },
              { month: 'Mar', value: 52000, pct: 100 },
              { month: 'Abr', value: 41000, pct: 82 },
            ].map((item) => (
              <div key={item.month} className="flex items-center gap-4">
                <span className="text-sm text-dark-500 w-10">{item.month}</span>
                <div className="flex-1 bg-dark-100 rounded-full h-3">
                  <div className="bg-green-500 rounded-full h-3" style={{ width: `${item.pct}%` }}></div>
                </div>
                <span className="text-sm font-medium text-dark-700 w-24 text-right">
                  {item.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
          <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Status dos Pedidos</h3>
          <div className="space-y-3">
            {[
              { label: 'Entregues', count: 156, color: 'bg-green-500', pct: 52 },
              { label: 'Em Transito', count: 78, color: 'bg-blue-500', pct: 26 },
              { label: 'Separacao', count: 42, color: 'bg-yellow-500', pct: 14 },
              { label: 'Pendentes', count: 24, color: 'bg-gray-400', pct: 8 },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-4">
                <div className={`w-3 h-3 rounded-full ${item.color}`}></div>
                <span className="text-sm text-dark-700 flex-1">{item.label}</span>
                <span className="text-sm font-medium text-dark-900">{item.count}</span>
                <span className="text-xs text-dark-500 w-10 text-right">{item.pct}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
